var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignalDataScada1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n      .cls-2 {\n        fill: #c9c9c9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fillRule: "evenodd",
    d: "M1,1H29V22H1V1ZM3,3H27V20H3V3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12,
    y: 22,
    width: 6,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8,
    y: 24.5,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 6,
    width: 6,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19,
    y: 6,
    width: 6,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11,
    y: 9.25,
    width: 6,
    height: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17,8.25 19.5,10 17,11.75"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalDataScada1);
export default __webpack_public_path__ + "static/media/signal-data-scada1.908633ea36eb6dc5f1db6e8d91bfacc5.svg";
export { ForwardRef as ReactComponent };